import axios from 'axios';

export const getLocationList = () => {
  return axios.get(`/npi/api/catalog?ats_id=1&geonim_id=0&lang=AUTO`);
};
